import { observable } from 'mobx';

export const FILTERS = {
  ALL: 'ALL',
  UNORDERED: 'UNORDERED',
  ORDERED: 'ORDERED',
  NOT_GEOLOCATED: 'NOT_GEOLOCATED',
};

export const filter = observable.box(FILTERS.ALL);



// WEBPACK FOOTER //
// ./src/store/filter.js